module.exports = __webpack_public_path__ + "img/pays.782e78d5.png";